import { fetchDataFromServer } from "../ServerCommunications";


export async function fetchIFEFieldSpots(selectedField) {
    try {
        const field = encodeURIComponent(selectedField);
        const viewPath = `ife_field_spots/${field}`;

        return await fetchDataFromServer(viewPath);
    } catch { }
};

export async function fetchIFEFieldPerDistrictSpots(field) {
    return fetchFieldSpecificData("ife_field_spots_per_district", field)
}

export async function fetchIFEFieldInDistrictSpots(field, district) {
    return fetchFieldSpecificData(
        "ife_field_spots_in_district",
        `${field}/${district}`
    )
}

export async function fetchIFELastFieldSpots(field) {
    return fetchFieldSpecificData("ife_field_last_spots", field)
}

async function fetchFieldSpecificData(view, path) {
    try {
        const encodedPath = path
            .split('/')
            .map(s => encodeURIComponent(s))
            .join('/');
        const viewPath = `${view}/${encodedPath}`;

        return await fetchDataFromServer(viewPath);
    } catch { }
}

export async function fetchAllFields() {
    return fetchAll("fields")
}

export async function fetchAllDistricts() {
    return fetchAll("districts")
}

async function fetchAll(viewPath) {
    try {
        return await fetchDataFromServer(viewPath);
    } catch { }
}